import React from 'react';
import { TextContent } from '../TextContent/TextContent';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';
import './SingleColumnText.scss';

export const SingleColumnText = ({ node }) => {
    const heading = node.relationships?.field_text?.field_heading ?? null;
    return (
        <ParentNodeProvider nodeName={heading} nodeType="Single_Column">
            <section
                className={`themed-container c--single-column-text ${node.field_theme?.toLowerCase()} ${node.field_lc_align?.toLowerCase()} ${
                    node.field_stackable ? `stackable` : ``
                }`}
            >
                <TextContent
                    className="kite-container"
                    node={node.relationships?.field_text}
                />
            </section>
        </ParentNodeProvider>
    );
};
